import { Link, TableBody, TableCell, TableRow } from '@material-ui/core'

import React, { FC } from 'react'

import { CategoryListInterface } from '../../interfaces/category'
import { convertDateTimeToString } from '../../utils/common'

const CategoryTableBody: FC<any> = ({
  categories
}: {
  categories: CategoryListInterface[]
}) => (
  <TableBody>
    {categories.map((category) => (
      <TableRow key={category.categoryId} hover={true}>
        <TableCell align="center">
          <Link href={`/category/${category.categoryId}/edit`}>
            {category.categoryId}
          </Link>
        </TableCell>
        <TableCell align="center">{category.sequentialNo}</TableCell>
        <TableCell align="center">{category.type}</TableCell>
        <TableCell align="center">{category.name}</TableCell>
        <TableCell align="center">
          {convertDateTimeToString(category.createdTime)}
        </TableCell>
        <TableCell align="center">
          {convertDateTimeToString(category.updatedTime)}
        </TableCell>
        <TableCell align="center">{category.updatedByEmail}</TableCell>
      </TableRow>
    ))}
  </TableBody>
)

export default CategoryTableBody
